module.exports = __webpack_public_path__ + "img/wading-operation.efa0a86.jpg";